import React from 'react'
import { Drawer, Skeleton } from 'antd'

import './index.css'

const getDrawerWidth = () => {
  if (window.innerWidth < 460) {
    return '85%'
  }
  return 580
}

export default function Sidebar({
  title = 'Order Details',
  loading = false,
  footer,
  visible = false,
  onClose,
  children,
}) {
  return loading ? (
    <Drawer
      zIndex={99}
      title={title}
      width={getDrawerWidth()}
      open={visible}
      onClose={onClose}
      maskClosable={true}
      closable={true}
      keyboard={true}
      destroyOnClose={true}
    >
      {[0, 1, 2, 3].map((sk) => {
        return (
          <Skeleton
            key={sk}
            title
            paragraph={{ rows: 2 }}
            loading={loading}
            active
            round
          />
        )
      })}
    </Drawer>
  ) : (
      <Drawer
        className='drwr'
        zIndex={99}
        width={getDrawerWidth()}
        title={title}
        onClose={onClose}
        open={visible}
        footer={footer}
        maskClosable={true}
        closable={true}
        keyboard={true}
        destroyOnClose={true}
      >
        {children}
      </Drawer>
    )
}
